export const lifedotCallCenterNumber = '0120-964-790'
export const lifedotDirectNumber = '0120-536-430'
export const lifedotChallengerNumber = '0120-527-369'
